import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b96766e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings page" }
const _hoisted_2 = { class: "container mx-auto pt-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mt-4 mb-4" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-5xl" }, "Settings:")
], -1))
const _hoisted_4 = { class: "public-key mt-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createTextVNode("← "),
  /*#__PURE__*/_createElementVNode("span", { class: "hover:underline" }, "Back")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "tip bg-yellow-100 border border-yellow-300 text-yellow-700 px-4 py-3 rounded relative mt-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://platform.openai.com/account/api-keys",
  class: "font-bold underline ml-1 sm:ml-0",
  target: "_blank"
}, " the page ", -1))
const _hoisted_9 = {
  key: 1,
  class: "tip bg-yellow-100 border border-yellow-300 text-yellow-700 px-4 py-3 rounded relative mt-2"
}
const _hoisted_10 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "GPT Run mode:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_GPTSettings = _resolveComponent("GPTSettings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheHeader),
    _createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "back flex-center mb-4 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _hoisted_6),
        _createVNode(_component_InputText, {
          value: _ctx.$root.apiKey,
          "onUpdate:value": _cache[1] || (_cache[1] = val => _ctx.setAPIKey(val)),
          label: "API Key",
          class: "flex-center ym-disable-keys lg:w-1/2"
        }, null, 8, ["value"]),
        (!_ctx.hasKey)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createTextVNode(" To get an API KEY you need to register new OPEN AI account (if you haven't) and then visit "),
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        (_ctx.showKeyInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " The key will saved only in your browser "))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$root.apiKey)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputSwitch, {
              value: _ctx.$root.mode,
              class: "mt-2",
              options: [{label: 'Client (With your API Key)', value: 'client'}, {label: 'Server', value: 'server'}],
              "onUpdate:value": _cache[2] || (_cache[2] = val => _ctx.setMode(val)),
              label: "Mode:"
            }, null, 8, ["value", "options"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_GPTSettings, {
        value: _ctx.gptSettings,
        "onUpdate:value": _ctx.updateGPTSettings
      }, null, 8, ["value", "onUpdate:value"])
    ])
  ]))
}